import { createEnumParam } from "use-query-params";

export type StreamerType = "innoactive" | "dcv";

export const StreamerTypeEnumParam = createEnumParam<StreamerType>([
  "innoactive",
  "dcv",
]);
